import { render, staticRenderFns } from "./SecurityDataPanel.vue?vue&type=template&id=00448240&scoped=true&"
import script from "./SecurityDataPanel.vue?vue&type=script&lang=js&"
export * from "./SecurityDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./SecurityDataPanel.vue?vue&type=style&index=0&id=00448240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00448240",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
